import React, { useEffect, useState } from "react";

// Chakra imports
import { Box, Button, Flex, Grid, Text, Avatar } from "@chakra-ui/react";
import axios from "axios";
import { CircularProgress, SnackbarContent } from "@mui/material";
import Snackbar from "@mui/material/Snackbar";
import { useLocation } from "react-router-dom";
import { columnsDataPurchaseHistory } from "./variables/columnsData";
import TablePurchased from "./components/TablePurchased";
import { Divider, LinearProgress } from "@mui/material";
import moment from "moment";
import { columnsDataPersonaPurchaseHistory } from "./variables/columnsDataPersona";
import { CgTrash } from "react-icons/cg";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import { styled } from "@mui/material/styles";
import { CloseIcon } from "@chakra-ui/icons";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

export default function PurchaseHistory() {
  const [user, setUser] = useState();
  const [purchasedProfiling, setPurchasedProfiling] = useState([]);
  const [purchasedPersona, setPurchasedPersona] = useState([]);
  const [purchasedMatching, setPurchasedMatching] = useState([]);
  // const [activeType, setActiveType] = useState('profiling');
  const [loadingItems, setLoadingItems] = useState({});
  const [paginationProfiling, setPaginationProfiling] = useState({
    limit: 5,
    page: 1,
    max: 1,
    total: 1,
  });
  const [paginationPersona, setPaginationPersona] = useState({
    limit: 5,
    page: 1,
    max: 1,
    total: 1,
  });
  const [matchingID, setMatchingID] = useState();
  const [open, setOpen] = useState(false);
  const [matching, setMatching] = useState();
  const [cardMatching, setCardMatching] = useState([]);
  const [stats, setStats] = useState();
  const [activeCard, setActiveCard] = useState(0);
  const [loadingDownload, setLoadingDownload] = useState(false);
  const [level, setLevel] = useState("");
  const [refetch, setRefetch] = useState(0);
  const location = useLocation();
  const [showDialog, setShowDialog] = useState(false);

  const [selectedId, setSelectedId] = useState();
  const [justPurchasedHistoryId, setJustPurchasedHistoryId] = useState(null);

  // const navigate = useNavigate()
  // const styles = useStyles();

  useEffect(() => {
    let localUser = localStorage.getItem("user");
    if (localUser) {
      setUser(JSON.parse(localUser));
    } else {
      // navigate('/')
    }
  }, []);

  useEffect(() => {
    let ignore = false;

    const openElement = () => {
      if (location.search && !ignore) {
        const item = location.search?.slice(1)?.split("?");
        const pairs = item[0]?.split("=");
        if (pairs[0] === "matchingID" && pairs[1]) {
          setMatchingID(Number(pairs[1]));
          // setActiveType('matching');
          setOpen(true);
        }
      } else if (location.hash && !ignore) {
        const item = location.hash.slice(1)?.split("#");
        // setActiveType(item[0])
      }
    };

    // Delay the open action to give time for rendering the target element
    const timeoutId = setTimeout(openElement, 500); // 500ms delay

    // Cleanup function
    return () => {
      clearTimeout(timeoutId);
      ignore = true;
    };
  }, [location.hash]);

  useEffect(() => {
    if (stats) {
      if (stats < 50) {
        setLevel("Average");
      } else if (stats < 60) {
        setLevel("Moderate");
      } else if (stats < 70) {
        setLevel("Intermediate");
      } else if (stats < 80) {
        setLevel("Leading");
      } else if (stats < 90) {
        setLevel("Advance");
      } else {
        setLevel("The BEST");
      }
    }
  }, [stats]);

  useEffect(() => {
    const token = localStorage.getItem("token");
    axios
      .get(
        `https://api.personatalenta.id/user/transaction?type=persona&limit=${paginationPersona.limit}&page=${paginationPersona.page}`,
        {
          headers: {
            Authorization: `Bearer ${token ? token : ""}`,
            "Content-Type": "x-www-from-urlencode",
          },
        },
      )
      .then((res) => {
        // if (res?.data?.transactions?.length > 0) {
        setPurchasedPersona(res?.data?.transactions);
        setPaginationPersona({
          ...paginationPersona,
          max: res.data.totalPages,
          total: res.data.totalCount,
        });
        // }
      })
      .catch((err) => {
        if (
          err.response.data.message === "Unauthorized" ||
          err.response.data === "Unauthorized"
        ) {
          // navigate('/');
        }
      });
    // }
  }, [paginationPersona.page, paginationPersona.limit, refetch]);

  useEffect(() => {
    const token = localStorage.getItem("token");
    // if (activeType === 'matching') {
    axios
      .get(`https://api.personatalenta.id/friends/matching/list`, {
        headers: {
          Authorization: `Bearer ${token ? token : ""}`,
          "Content-Type": "x-www-from-urlencode",
        },
      })
      .then((res) => {
        if (res?.data?.data) {
          setPurchasedMatching(res.data.data);
        }
      })
      .catch((err) => {
        if (
          err.response.data.message === "Unauthorized" ||
          err.response.data === "Unauthorized"
        ) {
          // navigate('/');
        }
      });
  }, [refetch]);

  useEffect(() => {
    const token = localStorage.getItem("token");
    axios
      .get(
        `https://api.personatalenta.id/user/transaction?type=profiling&limit=${paginationProfiling.limit}&page=${paginationProfiling.page}`,
        {
          headers: {
            Authorization: `Bearer ${token ? token : ""}`,
            "Content-Type": "x-www-from-urlencode",
          },
        },
      )
      .then((res) => {
        // if (res?.data?.transactions?.length > 0) {
        setPurchasedProfiling(res?.data?.transactions);
        setPaginationProfiling({
          ...paginationProfiling,
          max: res.data.totalPages,
          total: res.data.totalCount,
        });
        const lastPurchasedHistoryId = sessionStorage.getItem(
          "last_purchased_history_id",
        );
        if (lastPurchasedHistoryId) {
          try {
            setJustPurchasedHistoryId(JSON.parse(lastPurchasedHistoryId));
          } catch (e) {
            setJustPurchasedHistoryId({
              productId: parseInt(lastPurchasedHistoryId),
              visitorId: null,
            });
          }
          sessionStorage.removeItem("last_purchased_history_id");
        }
        // }
      })
      .catch((err) => {
        if (
          err.response?.data?.message === "Unauthorized" ||
          err.response?.data === "Unauthorized"
        ) {
          // navigate('/');
        }
      });
  }, [paginationProfiling.page, paginationProfiling.limit, refetch]);

  useEffect(() => {
    if (matchingID) {
      const token = localStorage.getItem("token");
      axios
        .get(`https://api.personatalenta.id/matching/detail/${matchingID}`, {
          headers: {
            Authorization: `Bearer ${token ? token : ""}`,
            "Content-Type": "x-www-from-urlencode",
          },
        })
        .then((res) => {
          if (res?.data) {
            setMatching(res?.data);
            setCardMatching(res?.data?.cards_general);
            // setMatchingCard(0);
            setStats(res?.data?.stats?.general);
            setActiveCard(1);
            // setPurchased(res.data.data)
          }
        })
        .catch((err) => {
          if (
            err.response?.data?.message === "Unauthorized" ||
            err?.response?.data === "Unauthorized"
          ) {
            // navigate('/');
          }
        });
    }
  }, [matchingID]);

  useEffect(() => {
    let localUser = localStorage.getItem("user");
    if (localUser) {
      setUser(JSON.parse(localUser));
      // console.log(user)
    } else {
      window.location.assign("/home");
    }
  }, []);

  const nextPageProfiling = () => {
    if (paginationProfiling.page < paginationProfiling.max) {
      setPaginationProfiling({
        ...paginationProfiling,
        page: paginationProfiling.page + 1,
      });
    }
  };

  const prevPageProfiling = () => {
    if (paginationProfiling.page > 1) {
      setPaginationProfiling({
        ...paginationProfiling,
        page: paginationProfiling.page - 1,
      });
    }
  };

  const firstPageProfiling = () => {
    setPaginationProfiling({ ...paginationProfiling, page: 1 });
  };

  const lastPageProfiling = (type) => {
    setPaginationProfiling({
      ...paginationProfiling,
      page: paginationProfiling.max,
    });
  };

  const goToPageProfiling = (type, page) => {
    setPaginationProfiling({ ...paginationProfiling, page: page });
  };

  const limitPageProfiling = (type, limit) => {
    setPaginationProfiling({ ...paginationProfiling, limit: limit });
  };

  const nextPagePersona = () => {
    if (paginationPersona.page < paginationPersona.max) {
      setPaginationPersona({
        ...paginationPersona,
        page: paginationPersona.page + 1,
      });
    }
  };

  const prevPagePersona = () => {
    if (paginationPersona.page > 1) {
      setPaginationPersona({
        ...paginationPersona,
        page: paginationPersona.page - 1,
      });
    }
  };

  const firstPagePersona = () => {
    setPaginationPersona({ ...paginationPersona, page: 1 });
  };

  const lastPagePersona = (type) => {
    setPaginationPersona({ ...paginationPersona, page: paginationPersona.max });
  };

  const goToPagePersona = (type, page) => {
    setPaginationPersona({ ...paginationPersona, page: page });
  };

  const limitPagePersona = (type, limit) => {
    setPaginationPersona({ ...paginationPersona, limit: limit });
  };

  const onClickAction = (props) => {
    if (props.type === "Download") {
      setLoadingDownload(true);
      setLoadingItems((prev) => ({ ...prev, [props.index]: true })); // Set individual item loading
      const token = localStorage.getItem("token");
      let baseUrl;
      if (props.product.user_id === user.id) {
        if (
          props.product.product.features === "Potential Talent Profiling Book"
        ) {
          baseUrl = `https://api.personatalenta.id/profiling/pdf/talent?user_id=${
            props.product.user_id
          }&type=${props.product.is_has_user_id ? 2 : 1}`;
        } else if (
          props.product.product.features === "Complete Profiling Book"
        ) {
          baseUrl = `https://api.personatalenta.id/profiling/pdf/complete?user_id=${
            props.product.user_id
          }&type=${props.product.is_has_user_id ? 2 : 1}`;
        } else if (props.product.product.features === "Career Profiling Book") {
          baseUrl = `https://api.personatalenta.id/profiling/pdf/career`;
        } else if (
          props.product.product.features === "Relationship Profiling Book"
        ) {
          baseUrl = `https://api.personatalenta.id/profiling/pdf/relation`;
        } else if (
          props.product.product.features === "Workstyle Profiling Book"
        ) {
          baseUrl = `https://api.personatalenta.id/profiling/pdf/workstyle`;
        }
      } else {
        if (
          props.product.product.features === "Potential Talent Profiling Book"
        ) {
          baseUrl = `https://api.personatalenta.id/profiling/pdf/talent?user_id=${
            props.product.user_id
          }&type=${props.product.is_has_user_id ? 2 : 1}`;
        } else if (
          props.product.product.features === "Complete Profiling Book"
        ) {
          baseUrl = `https://api.personatalenta.id/profiling/pdf/complete?user_id=${
            props.product.user_id
          }&type=${props.product.is_has_user_id ? 2 : 1}`;
        } else if (props.product.product.features === "Career Profiling Book") {
          baseUrl = `https://api.personatalenta.id/profiling/pdf/career?type=${
            props.product.is_has_user_id ? 2 : 1
          }&user_id=${props.product.user_id}`;
        } else if (
          props.product.product.features === "Relationship Profiling Book"
        ) {
          baseUrl = `https://api.personatalenta.id/profiling/pdf/relation?type=${
            props.product.is_has_user_id ? 2 : 1
          }&user_id=${props.product.user_id}`;
        } else if (
          props.product.product.features === "Workstyle Profiling Book"
        ) {
          baseUrl = `https://api.personatalenta.id/profiling/pdf/workstyle?type=${
            props.product.is_has_user_id ? 2 : 1
          }&user_id=${props.product.user_id}`;
        }
      }

      axios
        .get(baseUrl, {
          headers: {
            Authorization: `Bearer ${token ? token : ""}`,
            "Content-Type": "x-www-from-urlencode",
          },
          responseType: "blob",
        })
        .then((res) => {
          // setLoading(false)
          setLoadingDownload(false);
          const a = document.createElement("a");
          a.href = window.URL.createObjectURL(res.data);
          a.download = `${
            props.product.product.features === "Career Profiling Book"
              ? "Karir Terbaik Untuk"
              : props.product.product.features
          } ${props.product.user?.name ?? props.product.colleague?.name}.pdf`;
          document.body.appendChild(a);
          a.click();
          a.remove();
        })
        .catch((err) => {
          if (
            err.response?.data?.message === "Unauthorized" ||
            err.response?.data === "Unauthorized"
          ) {
            // navigate('/');
          }
        })
        .finally(() => {
          setLoadingItems((prev) => ({ ...prev, [props.index]: false })); // Reset loading after completion
        });
    } else if (props.type === "Web") {
      if (user.id === props.product.user_id) {
        if (props.product.product.features === "Standard Profiling Book") {
          window.location.assign(
            `/dashboard/profile/${
              user?.username !== "" &&
              user?.username !== undefined &&
              user?.username !== null
                ? user.username
                : user?.id
            }/profiling-standard-web`,
          );
        } else if (
          props.product.product.features === "Complete Profiling Book"
        ) {
          window.location.assign(
            `/dashboard/profile/${
              user?.username !== "" &&
              user?.username !== undefined &&
              user?.username !== null
                ? user.username
                : user?.id
            }/profiling-complete-web`,
          );
        } else if (props.product.product.name === "Profiling Web") {
          window.location.assign(
            `/dashboard/profile/${
              user?.username !== "" &&
              user?.username !== undefined &&
              user?.username !== null
                ? user.username
                : user?.id
            }/profiling-web`,
          );
        } else if (
          props.product.product.name === "Daily Vibe Persona" ||
          props.product.product.name === "General Persona"
        ) {
          window.location.assign(
            `/dashboard/profile/${
              user?.username !== "" &&
              user?.username !== undefined &&
              user?.username !== null
                ? user.username
                : user?.id
            }/persona-web`,
          );
        } else if (props.product.product.name === "Matching") {
          window.location.assign(`/matching`);
        }
      } else {
        if (props.product.product.features === "Standard Profiling Book") {
          window.location.assign(
            `/dashboard/friend-list/${
              props.product.is_has_user_id ? "friend" : "colleague"
            }/${
              props.product.is_has_user_id
                ? props.product.user.id
                : props.product.colleague.id
            }/profiling-standard-web`,
          );
        } else if (
          props.product.product.features === "Complete Profiling Book"
        ) {
          window.location.assign(
            `/dashboard/friend-list/${
              props.product.is_has_user_id ? "friend" : "colleague"
            }/${
              props.product.is_has_user_id
                ? props.product.user.id
                : props.product.colleague.id
            }/profiling-complete-web`,
          );
        } else if (props.product.product.name === "Profiling Web") {
          window.location.assign(
            `/dashboard/friend-list/${
              props.product.is_has_user_id ? "friend" : "colleague"
            }/${
              props.product.is_has_user_id
                ? props.product.user.id
                : props.product.colleague.id
            }/profiling-web`,
          );
        } else if (
          props.product.product.name === "Daily Vibe Persona" ||
          props.product.product.name === "General Persona"
        ) {
          window.location.assign(
            `/dashboard/friend-list/${
              props.product.is_has_user_id ? "friend" : "colleague"
            }/${
              props.product.is_has_user_id
                ? props.product.user.id
                : props.product.colleague.id
            }/persona-web`,
          );
        } else if (props.product.product.name === "Matching") {
          window.location.assign(
            `/dashboard/friend-list/${
              props.product.is_has_user_id ? "friend" : "colleague"
            }/${
              props.product.is_has_user_id
                ? props.product.user.id
                : props.product.colleague.id
            }/matching-web`,
          );
        }
      }
    } else if (props.type === "Buy") {
      if (user.id === props.product.user_id && props.product.is_has_user_id) {
        if (
          props.product.product.features === "Standard Profiling Book" ||
          props.product.product.features === "Complete Profiling Book"
        ) {
          window.location.assign(`/pricing#profiling`);
        } else if (props.product.product.name === "Daily Vibe Persona") {
          window.location.assign(`/pricing#persona`);
        } else if (props.product.product.name === "General Persona") {
          window.location.assign(`/pricing#persona`);
        } else if (props.product.product.name === "Profiling Web") {
          window.location.assign(`/pricing#profiling`);
        } else if (props.product.product.name === "Matching") {
          window.location.assign(`/pricing#matching`);
        }
      } else {
        if (
          props.product.product.features === "Standard Profiling Book" ||
          props.product.product.features === "Complete Profiling Book"
        ) {
          window.location.assign(
            `/pricing#profiling?type=${
              props.product.is_has_user_id ? "friend" : "colleague"
            }&id=${
              props.product.is_has_user_id
                ? props.product.user.id
                : props.product.colleague.id
            }`,
          );
        } else if (props.product.product.name === "Daily Vibe Persona") {
          window.location.assign(
            `/pricing#persona?type=${
              props.product.is_has_user_id ? "friend" : "colleague"
            }&id=${
              props.product.is_has_user_id
                ? props.product.user.id
                : props.product.colleague.id
            }`,
          );
        } else if (props.product.product.name === "General Persona") {
          window.location.assign(
            `/pricing#persona?type=${
              props.product.is_has_user_id ? "friend" : "colleague"
            }&id=${
              props.product.is_has_user_id
                ? props.product.user.id
                : props.product.colleague.id
            }`,
          );
        } else if (props.product.product.name === "Profiling Web") {
          window.location.assign(
            `/pricing#profiling?type=${
              props.product.is_has_user_id ? "friend" : "colleague"
            }&id=${
              props.product.is_has_user_id
                ? props.product.user.id
                : props.product.colleague.id
            }`,
          );
        } else if (props.product.product.name === "Matching") {
          window.location.assign(
            `/pricing#matching?type=${
              props.product.is_has_user_id ? "friend" : "colleague"
            }&id=${
              props.product.is_has_user_id
                ? props.product.user.id
                : props.product.colleague.id
            }`,
          );
        }
      }
    }
  };

  // const onChangeMenu = menu => {
  //   setPurchased([])
  //   setActiveType((menu))
  // }

  const setDetailMatching = (item) => {
    if (moment(item.expired_at).isAfter(new Date(), "days")) {
      if (matchingID !== item.id) {
        setMatchingID(item.id);
        if (item.expired_at && moment(item.expired_at).isAfter(new Date())) {
          window.location.assign(`/dashboard/profile/matching/${item.id}`);
        }
      } else {
        setMatchingID();
        setOpen(false);
      }
    } else {
      window.location.assign("/pricing#matching");
    }
  };

  const onClickCard = (props) => {
    setActiveCard(props);
    // setMatchingCard(props);
    if (matching) {
      if (props === 1) {
        setCardMatching(matching.cards_general);
        setStats(matching?.stats?.general);
      } else if (props === 2) {
        setCardMatching(matching.cards_daily);
        setStats(matching?.stats?.today);
      }
    }
  };

  const handleClose = () => {
    setLoadingDownload(false);
  };

  const onDeleteMatching = (id) => {
    const token = localStorage.getItem("token");
    axios
      .put(
        `https://api.personatalenta.id/matching/hide/hide/${id}`,
        {},
        {
          headers: {
            Authorization: `Bearer ${token ? token : ""}`,
            "Content-Type": "x-www-from-urlencode",
          },
        },
      )
      .then((res) => {
        setRefetch(refetch + 1);
      })
      .catch((err) => {
        if (
          err.response?.data?.message === "Unauthorized" ||
          err?.response?.data === "Unauthorized"
        ) {
          // navigate('/');
        }
      });
  };

  const onDeletePersona = (id) => {
    const token = localStorage.getItem("token");
    axios
      .put(
        `https://api.personatalenta.id/user/transaction/hide/hide/${id}`,
        {},
        {
          headers: {
            Authorization: `Bearer ${token ? token : ""}`,
            "Content-Type": "x-www-from-urlencode",
          },
        },
      )
      .then((res) => {
        setRefetch(refetch + 1);
      })
      .catch((err) => {
        if (
          err.response?.data?.message === "Unauthorized" ||
          err?.response?.data === "Unauthorized"
        ) {
          // navigate('/');
        }
      });
  };

  const onOpenDialog = (id) => {
    setShowDialog(true);
    setSelectedId(id);
  };

  const onCloseDialog = () => {
    setShowDialog(false);
    setSelectedId(null);
  };

  const onConfirmDelete = () => {
    onDeleteMatching(selectedId);
    setShowDialog(false);
    setSelectedId(null);
  };

  const action = (
    <div>
      <CircularProgress size={25} />
    </div>
  );

  return (
    <Box
      id="history"
      width={{ sm: "90vw", md: "100%" }}
      overflowX={{ sm: "hidden", lg: "hidden" }}
      pt={{ sm: 5, base: "130px", md: "80px", xl: "80px" }}
    >
      <Grid gap={{ base: "20px", xl: "20px" }} mt={0}>
        <Flex flexDirection="column" gap={5}>
          <Flex flexDirection="column" width={{ sm: "90vw", md: "100%" }}>
            <Flex gap={{ sm: 1, md: 30 }} flex={1}>
              <Flex
                width={{ sm: "100%", md: "20%" }}
                borderColor="#2458EA"
                borderWidth={1}
                borderTopRadius={8}
                padding="5px 10px"
                backgroundColor={"#2458EA"}
              >
                <Text
                  fontSize={{ sm: "xs", md: "sm" }}
                  color={"#FFF"}
                  fontWeight={"bold"}
                >
                  PURCHASED PROFILING
                </Text>
              </Flex>
            </Flex>
            <TablePurchased
              columnsData={columnsDataPurchaseHistory}
              tableData={purchasedProfiling}
              pagination={paginationProfiling}
              nextPage={nextPageProfiling}
              prevPage={prevPageProfiling}
              firstPage={firstPageProfiling}
              lastPage={lastPageProfiling}
              limitPage={limitPageProfiling}
              goToPage={goToPageProfiling}
              onClickAction={onClickAction}
              loading={loadingItems}
              type="profiling"
              justPurchasedHistoryId={justPurchasedHistoryId}
            />
          </Flex>
          <Flex
            flexDirection="column"
            gap={{ sm: 1, md: 2 }}
            width={{ sm: "90vw", md: "100%" }}
          >
            <Flex gap={{ sm: 1, md: 30 }} flex={1}>
              <Flex
                width={{ sm: "100%", md: "20%" }}
                borderColor="#2458EA"
                borderWidth={1}
                borderTopRadius={8}
                padding="5px 10px"
                backgroundColor={"#2458EA"}
              >
                <Text
                  fontSize={{ sm: "xs", md: "sm" }}
                  color={"#FFF"}
                  fontWeight={"bold"}
                >
                  PURCHASED MATCHING
                </Text>
              </Flex>
            </Flex>
            <Flex
              flexDir="row"
              gap={1}
              flexWrap="wrap"
              width={{ sm: "100%", md: "89%" }}
              mt={{ sm: 0, md: 0 }}
            >
              <Flex
                borderBottomWidth={1}
                flexDirection="row"
                // py={2}
                gap={{ sm: 3, md: 0 }}
                backgroundColor={"#6FE6FC"}
                minWidth="90%"
              >
                <Flex
                  borderColor="#6FE6FC"
                  borderWidth={1}
                  borderTopRadius={8}
                  padding="5px 2px"
                  backgroundColor={"#6FE6FC"}
                  width={{ sm: 210, md: 550 }}
                  gap={2}
                  px={1}
                >
                  <Text
                    color="#000"
                    fontSize={{ sm: "xs", md: "sm" }}
                    fontWeight="bold"
                  >
                    MATCHED RESULT
                  </Text>
                </Flex>
                <Flex
                  borderColor="#6FE6FC"
                  borderWidth={1}
                  borderTopRadius={8}
                  padding="5px 2px"
                  backgroundColor={"#6FE6FC"}
                  width={{ sm: 70, md: 100 }}
                  gap={2}
                  justifyContent="center"
                >
                  <Text
                    color="#000"
                    fontSize={{ sm: "xs", md: "sm" }}
                    fontWeight="bold"
                  >
                    ACTION
                  </Text>
                </Flex>
                <Flex
                  borderColor="#6FE6FC"
                  borderWidth={1}
                  borderTopRadius={8}
                  padding="5px 2px"
                  backgroundColor={"#6FE6FC"}
                  width={{ sm: 100, md: 130 }}
                  gap={2}
                  justifyContent="center"
                >
                  <Text
                    color="#000"
                    fontSize={{ sm: "xs", md: "sm" }}
                    fontWeight="bold"
                  >
                    PERIODE
                  </Text>
                </Flex>
              </Flex>
              {purchasedMatching.length > 0 &&
                purchasedMatching.map((item, index) => (
                  <Flex key={index} direction="column">
                    <Flex
                      borderBottomWidth={1}
                      flexDirection="row"
                      py={2}
                      gap={{ sm: 3, md: 5 }}
                      minWidth="45%"
                    >
                      <Flex
                        direction="column"
                        justifyContent="center"
                        alignItems="end"
                        minWidth={{ sm: 30, md: 70 }}
                      >
                        <Avatar
                          src={
                            item.users?.user1?.photo ??
                            item?.users?.colleague1?.photo
                          }
                          h={{ sm: "30px", md: "40px" }}
                          w={{ sm: "30px", md: "40px" }}
                          border="1px solid #059212"
                        />
                        <Text
                          fontSize={{ sm: "xs", md: "sm" }}
                          textOverflow="ellipsis"
                          whiteSpace="nowrap"
                          overflow="hidden"
                          maxWidth={"70px"}
                        >
                          {item?.users?.user1?.name ??
                            item?.users?.colleague1?.name}
                        </Text>
                      </Flex>
                      <Flex
                        direction="column"
                        justifyContent="center"
                        minWidth={{ sm: 30, md: 70 }}
                      >
                        <Avatar
                          src={
                            item.users?.user2?.photo ??
                            item?.users?.colleague2?.photo
                          }
                          h={{ sm: "30px", md: "40px" }}
                          w={{ sm: "30px", md: "40px" }}
                          border="1px solid #059212"
                        />
                        <Text
                          fontSize={{ sm: "xs", md: "sm" }}
                          textOverflow="ellipsis"
                          whiteSpace="nowrap"
                          overflow="hidden"
                          maxWidth={"70px"}
                        >
                          {item?.users?.user2?.name ??
                            item?.users?.colleague2?.name}
                        </Text>
                      </Flex>
                      <Flex direction="column" gap={1} justifyContent="center">
                        <Text fontSize={{ sm: "xs", md: "sm" }}>General</Text>
                        <Text fontSize={{ sm: "xs", md: "sm" }}>Daily</Text>
                      </Flex>
                      <Flex
                        direction="column"
                        width={{ sm: 50, md: 300 }}
                        gap={2}
                        justifyContent="center"
                      >
                        <Box width="100%" position="relative">
                          <LinearProgress
                            sx={{
                              height: 24,
                              borderRadius: 1,
                              width: "100%",
                              position: "absolute",
                            }}
                            color={
                              item.matching_type === 0
                                ? "warning"
                                : item.matching_type === 1
                                  ? "error"
                                  : "info"
                            }
                            variant="determinate"
                            value={item?.stats?.general}
                          />
                          <Text
                            fontSize={{ sm: "xs", md: "sm" }}
                            color="white"
                            fontWeight="bold"
                            zIndex={1}
                            position="relative"
                            textAlign="center"
                          >
                            {item?.stats?.general}%
                          </Text>
                        </Box>
                        <Box width="100%" position="relative">
                          <LinearProgress
                            sx={{
                              height: 24,
                              borderRadius: 1,
                              width: "100%",
                              position: "absolute",
                            }}
                            color={
                              item.matching_type === 0
                                ? "warning"
                                : item.matching_type === 1
                                  ? "error"
                                  : "info"
                            }
                            variant="determinate"
                            value={item?.stats?.today}
                          />
                          <Text
                            fontSize={{ sm: "xs", md: "sm" }}
                            color="white"
                            fontWeight="bold"
                            zIndex={1}
                            position="relative"
                            textAlign="center"
                          >
                            {item?.stats?.today}%
                          </Text>
                        </Box>
                      </Flex>
                      <Flex direction="row" gap={{ sm: 1, md: 2 }}>
                        <Flex
                          alignItems="center"
                          justifyContent="center"
                          cursor="pointer"
                          onClick={() => setDetailMatching(item)}
                          width={{ sm: 50, md: 62 }}
                          direction="column"
                          gap={1}
                        >
                          <Text
                            fontSize={{ sm: "xs", md: "sm" }}
                            bgColor={
                              item.expired_at &&
                              moment(item.expired_at).isAfter(new Date())
                                ? "#2458EA"
                                : "#2458EA"
                            }
                            borderRadius={5}
                            textAlign="center"
                            width="100%"
                            py="5px"
                            color="#fff"
                          >
                            {item.expired_at &&
                            moment(item.expired_at).isAfter(new Date())
                              ? "View"
                              : "Beli lagi"}
                          </Text>
                        </Flex>
                        <Flex
                          width={{ sm: 5, md: 5 }}
                          direction="column"
                          gap={1}
                          justifyContent="center"
                        >
                          <Flex
                            cursor="pointer"
                            border="2px solid #2458EA"
                            borderRadius={5}
                            paddingY="5px"
                            alignItems="center"
                            justifyContent="center"
                            width="25px"
                            onClick={() => onOpenDialog(item.id)}
                          >
                            <CgTrash color="#2458EA" />
                          </Flex>
                        </Flex>
                      </Flex>
                      <Flex
                        width={{ sm: 82, md: 200 }}
                        direction="column"
                        gap={1}
                        justifyContent="center"
                      >
                        <Text
                          fontSize={{ sm: "xs", md: "sm" }}
                          color={
                            moment(item.expired_at).isSameOrBefore(
                              Date.now(),
                              "day",
                            )
                              ? "red"
                              : "black"
                          }
                        >
                          {moment(item.created_at).format("DD MMM")} -{" "}
                          {item.expired_at
                            ? moment(item.expired_at).format("DD MMM YYYY")
                            : "-"}
                        </Text>
                      </Flex>
                    </Flex>
                    {item.id === matchingID && open && (
                      <div>
                        <Flex gap={3}>
                          <Button
                            bgColor={
                              cardMatching.length === 0
                                ? "gray"
                                : activeCard === 1
                                  ? "#3572EF"
                                  : "white"
                            }
                            color={
                              activeCard === 1 || cardMatching.length === 0
                                ? "white"
                                : "#3572EF"
                            }
                            borderWidth={1}
                            borderColor="#3572EF"
                            fontSize={{ sm: "xs", md: "sm" }}
                            fontWeight="bold"
                            borderRadius="5px"
                            onClick={() => onClickCard(1)}
                            disabled={cardMatching.length === 0}
                            px={{ sm: "10px", md: "30px" }}
                            py="5px"
                          >
                            General match
                          </Button>
                          <Button
                            bgColor={
                              cardMatching.length === 0
                                ? "gray"
                                : activeCard === 2
                                  ? "#3572EF"
                                  : "white"
                            }
                            color={
                              activeCard === 2 || cardMatching.length === 0
                                ? "white"
                                : "#3572EF"
                            }
                            borderWidth={1}
                            borderColor="#3572EF"
                            fontSize={{ sm: "xs", md: "sm" }}
                            fontWeight="bold"
                            borderRadius="5px"
                            onClick={() => onClickCard(2)}
                            disabled={cardMatching.length === 0}
                            px={{ sm: "10px", md: "30px" }}
                            py="5px"
                          >
                            Daily match
                          </Button>
                        </Flex>
                        {matching && (
                          <Flex
                            flexDirection="column"
                            width={{ md: "100%" }}
                            borderWidth={1}
                            borderRadius={15}
                            px={0}
                            py={5}
                            gap={5}
                          >
                            {cardMatching.map((card, index) => (
                              <Flex direction="column" key={index}>
                                <Text
                                  fontWeight="bold"
                                  textTransform="uppercase"
                                  color="#B82132"
                                  fontSize={{ sm: "sm", md: "md" }}
                                >
                                  {card.title}
                                </Text>
                                <Flex
                                  position="relative"
                                  flexDirection="column"
                                  borderWidth={0.5}
                                  borderRadius={15}
                                  padding={2}
                                  borderColor="lightgrey"
                                >
                                  {card.texts.map((text) => (
                                    <>
                                      {text.map((item, i) => {
                                        // if (item.title && item.text) {
                                        return (
                                          <Flex
                                            key={i}
                                            direction="column"
                                            gap={1}
                                            padding={2}
                                          >
                                            <Text
                                              fontWeight="bold"
                                              fontSize={{ sm: "xs", md: "md" }}
                                            >
                                              {item.title != "null" &&
                                                item.title}
                                            </Text>
                                            <Text
                                              whiteSpace="pre-line"
                                              fontSize={{ sm: "xs", md: "md" }}
                                            >
                                              {item.text}
                                            </Text>
                                            {/* <Text color="#050C9C" fontSize={{ sm: "xs", md: "md" }} fontStyle="italic" textAlign="end" mt={0} cursor="pointer" onClick={() => onClickOpen(item.text)}>{isUnlocked && item.text !== open ? "Read more" : isUnlocked && item.text === open ? "Show less" : "Deep dive"}</Text> */}
                                          </Flex>
                                        );
                                        // }
                                      })}
                                    </>
                                  ))}
                                </Flex>
                              </Flex>
                            ))}
                          </Flex>
                        )}
                      </div>
                    )}
                  </Flex>
                ))}
            </Flex>
          </Flex>
          <Flex flexDirection="column" width={{ sm: "90vw", md: "100%" }}>
            <Flex gap={{ sm: 1, md: 30 }} flex={1}>
              <Flex
                width={{ sm: "100%", md: "20%" }}
                borderColor="#2458EA"
                borderWidth={1}
                borderTopRadius={8}
                padding="5px 10px"
                backgroundColor={"#2458EA"}
              >
                <Text
                  fontSize={{ sm: "xs", md: "sm" }}
                  color={"#FFF"}
                  fontWeight={"bold"}
                >
                  PURCHASED PERSONA
                </Text>
              </Flex>
            </Flex>
            <TablePurchased
              columnsData={columnsDataPersonaPurchaseHistory}
              tableData={purchasedPersona}
              pagination={paginationPersona}
              nextPage={nextPagePersona}
              prevPage={prevPagePersona}
              firstPage={firstPagePersona}
              lastPage={lastPagePersona}
              limitPage={limitPagePersona}
              goToPage={goToPagePersona}
              onClickAction={onClickAction}
              loading={loadingItems}
              type="persona"
              onDeletePersona={onDeletePersona}
            />
          </Flex>
        </Flex>
      </Grid>
      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        open={loadingDownload}
        onClose={handleClose}
        style={{ top: 50 }}
      >
        <SnackbarContent
          style={{ height: 80, backgroundColor: "#CADFB8", color: "#000" }}
          action={action}
          message={
            <div>
              <span id="client-snackbar">
                Saat ini dokumen sedang proses download, kecepatan bergantung
                pada jaringan anda
              </span>
            </div>
          }
        />
      </Snackbar>
      <BootstrapDialog
        onClose={onCloseDialog}
        aria-labelledby="customized-dialog-title"
        open={showDialog}
      >
        <DialogTitle
          sx={{ m: 0, p: 3, backgroundColor: "#D5DDFC" }}
          id="customized-dialog-title"
        ></DialogTitle>
        <IconButton
          aria-label="close"
          onClick={onCloseDialog}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon width={3} />
        </IconButton>
        <DialogContent>
          <Flex
            flexDirection="column"
            wrap="wrap"
            maxWidth="100%"
            gap={1}
            alignItems="center"
            justifyContent="center"
          >
            <Text>
              Apakah kamu akan menghapus User ini dari daftar List saat ini?
            </Text>
          </Flex>
        </DialogContent>
        <DialogActions sx={{ justifyContent: "center" }}>
          <Button
            borderWidth={1}
            // borderColor="#1877f2"
            bg={"green"}
            color="white"
            fontSize="sm"
            fontWeight="bold"
            borderRadius="5px"
            px="10px"
            py="5px"
            onClick={() => onConfirmDelete()}
            // disabled={pagination.page === pagination.max}
          >
            Ya
          </Button>
        </DialogActions>
      </BootstrapDialog>
    </Box>
  );
}
